"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("templateUtils", function ($q, $http, $templateCache) {
  return {
    load: function load(templateUrl) {
      return $http.get(templateUrl, {
        cache: $templateCache
      }).then(function (result) {
        return result.data;
      });
    },
    /**
     * Utility class to load template from given config (like angular for routes config for example)
     * accepting both the "template" or the "templateUrl" option
     *
     * @param {Object} config The config object to extract 'template' or 'templateUrl' from.
     * @return {Promise} Promise resolving with the
     */
    loadTemplate: function loadTemplate(config) {
      return config.template ? $q.when(config.template) : $http.get(config.templateUrl, {
        cache: $templateCache
      }).then(function (result) {
        return result.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/templateUtils.js
// module id = 2766
// module chunks = 13